// Helper de "atualizar agora" — limpa caches do browser, desregistra
// service workers (PWA shell) e força hard reload. Usado pelo gate de
// versão e pelo link "Atualizar" no rodapé do menu. Em dev só recarrega
// — caches/SW não estão em uso.

const TAG = 'admin/force-update';

/**
 * Limpa Cache Storage e service workers e recarrega a página.
 *
 * Origem: sem issue — commit 17dc7b267, 2026-06-19 (gate de versão com force
 * update no admin).
 *
 * Contrato: nunca rejeita; falha na limpeza só vai para o console e o reload
 * acontece mesmo assim.
 *
 * Usado por: `components/AppVersionGate.tsx` e `components/NavVersionFooter.tsx`.
 */
export async function forceUpdate(): Promise<void> {
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (err) {
    // Não-bloqueante: mesmo que limpeza falhe, ainda vamos reload.
    console.warn(`${TAG}: cleanup failed (continuing reload)`, err);
  }
  // `location.reload()` em browsers modernos já busca o `index.html`
  // do servidor (assets versionados por hash); a limpeza acima cuida
  // de PWAs cacheadas.
  window.location.reload();
}
